
import ServiceCard from './ServiceCard';

const services = [
  {
    title: "Washer Repair",
    description: "Trusted Repairs for All Washing Machine Models and Brands",
    image: "/lovable-uploads/e8e18826-285a-4452-8912-0793e5e59e4a.png",
    alt: "Professional washer repair service showing Bosch washing machine repair",
    path: "/services/washer-repair"
  },
  {
    title: "Dryer Repair",
    description: "From no heat to faulty tumbling, we've got you covered.",
    image: "/lovable-uploads/c60296eb-c347-41fb-bd80-596675c832c1.png",
    alt: "Expert dryer repair showing internal dryer components",
    path: "/services/dryer-repair"
  },
  {
    title: "Dishwasher Repair",
    description: "Restore your dishwasher's efficiency, performance and drainage",
    image: "/lovable-uploads/2d164f8f-316d-4105-b0a9-18b101fdb2fc.png",
    alt: "KitchenAid dishwasher repair service",
    path: "/services/dishwasher-repair"
  },
  {
    title: "Stove Repair",
    description: "Solve issues like uneven heating, dead burners, and more.",
    image: "/lovable-uploads/0f2976d8-1621-4d83-b761-2af0d911859a.png",
    alt: "Professional stove repair showing stove diagnostic",
    path: "/services/stove-repair"
  },
  {
    title: "Refrigerator Repair",
    description: "Handle cooling problems, water leaks, and ice maker malfunctions effortlessly.",
    image: "/lovable-uploads/2019b980-f8e1-46ec-8c0b-26c20616bda0.png",
    alt: "Emergency refrigerator repair showing oven repair work",
    path: "/services/refrigerator-repair"
  },
  {
    title: "Oven Repair",
    description: "Fix temperature inconsistencies, faulty doors, and heating elements.",
    image: "/lovable-uploads/ef128e50-c278-44dc-b162-50c2b5841ce0.png",
    alt: "Trusted oven repair service showing washing machine repair",
    path: "/services/oven-repair"
  }
];

const ServicesList = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
      {services.map((service, index) => (
        <ServiceCard key={index} {...service} />
      ))}
    </div>
  );
};

export default ServicesList;
